/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// ════════════════════════════════════════════════════════════════
// Shared "other apps you'll love" cross-sell section (bh design system).
// Rendered inside a <main className="bh"> page. Lists the other seven
// BuddiesHR apps, excluding the current one. Used by the Alfy and Billy
// product pages (components/{alfy,billy}/pageSections.js).
// ════════════════════════════════════════════════════════════════
import React from 'react';
import Link from 'next/link';

// The full suite. `id` matches the per-app pastel tokens in bh-tokens.css
// and lets each page exclude itself from the grid.
const ALL_APPS = [
  { id: 'alfy', name: 'Alfy', tag: 'Donut & coffee chats', href: '/random-coffee', logo: '/img/apps/alfy/logo.png', bg: 'var(--app-alfy-bg)', color: 'var(--app-alfy)' },
  { id: 'billy', name: 'Billy', tag: 'Birthday bot', href: '/birthday-bot', logo: '/img/apps/billy/logo.png', bg: 'var(--app-billy-bg)', color: 'var(--app-billy)' },
  { id: 'clappy', name: 'Clappy', tag: 'Kudos & shoutouts', href: '/kudos-recognition', logo: '/img/apps/clappy/logo.png', bg: 'var(--app-clappy-bg)', color: 'var(--app-clappy)' },
  { id: 'linky', name: 'Linky', tag: 'Org chart', href: '/org-chart', logo: '/img/apps/linky/logo.png', bg: 'var(--app-linky-bg)', color: 'var(--app-linky)' },
  { id: 'palmy', name: 'Palmy', tag: 'Vacation tracker', href: '/vacation-tracker', logo: '/img/apps/palmy/logo.png', bg: 'var(--app-palmy-bg)', color: 'var(--app-palmy)' },
  { id: 'pulsy', name: 'Pulsy', tag: 'eNPS, polls & surveys', href: '/employee-survey', logo: '/img/apps/pulsy/logo.png', bg: 'var(--app-pulsy-bg)', color: 'var(--app-pulsy)' },
  { id: 'stany', name: 'Stany', tag: 'Async standups', href: '/standup-bot', logo: '/img/apps/stany/logo.png', bg: 'var(--app-stany-bg)', color: 'var(--app-stany)' },
  { id: 'perf', name: 'SimplePerf', tag: '360° performance reviews', href: '/performance-reviews', logo: '/img/logo/simpleperf.png', bg: 'var(--app-perf-bg)', color: 'var(--app-perf)' },
];

// `currentApp` is the id to exclude (e.g. 'alfy', 'billy').
// `accent` is the raw hex accent for the current app, used on the heading.
// `background` lets the caller match its page's alternating section rhythm.
export default function AppsCrossSell({ currentApp, accent, background = 'var(--bh-cream-deep)' }) {
  const current = ALL_APPS.find((a) => a.id === currentApp);
  const name = current ? current.name : 'It';
  const others = ALL_APPS.filter((a) => a.id !== currentApp);

  return (
    <section className="bh-section" style={{ background }}>
      <div style={{ maxWidth: 1240, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '.14em', color: 'var(--bh-ink-mute)', textTransform: 'uppercase', marginBottom: 10 }}>
            Other apps you&rsquo;ll love
          </div>
          <h2 style={{ fontSize: 'clamp(34px, 4.4vw, 50px)', letterSpacing: '-0.03em', lineHeight: 1, maxWidth: 720, margin: '0 auto' }}>
            {name} plays nice with all <span style={{ fontStyle: 'italic', color: accent }}>seven</span> of its friends.
          </h2>
        </div>
        <div className="bh-grid-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
          {others.map((o) => (
            <Link
              key={o.id}
              href={o.href}
              style={{
                background: o.bg,
                borderRadius: 'var(--bh-r-lg)',
                padding: 22,
                border: `1px solid ${o.color}22`,
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                transition: 'transform .2s',
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
              onMouseOut={(e) => (e.currentTarget.style.transform = '')}
            >
              <img src={o.logo} alt={`${o.name} logo`} style={{ width: 48, height: 48, flexShrink: 0 }} />
              <div>
                <div style={{ fontFamily: 'var(--bh-font-display)', fontSize: 18, fontWeight: 600, letterSpacing: '-0.02em' }}>{o.name}</div>
                <div style={{ fontSize: 13, color: 'var(--bh-ink-mute)' }}>{o.tag}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
